import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {ConnectedRouter} from 'react-router-redux';
import {Notifs, actions as notifActions} from 'redux-notifications';

import Confirmation from './../confirmation';
import {pageInitializationActionTypes} from './../../consts';
import actions from './../../actions';
import {getMessage} from "../../utils/i18n";
import Loading from './../../components/loading';
import Header from './../../components/header';
import Body from './../../routes';
import Notification from './../../components/notification';

class Skeleton extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        pageStatus: PropTypes.string.isRequired,
        initialize: PropTypes.func.isRequired,
        notify: PropTypes.func.isRequired
    };

    componentWillMount() {
        this.props.initialize();
    };

    componentWillUpdate(nextProps) {
        nextProps.pageStatus === pageInitializationActionTypes.PAGE_INITIALIZATION_FAIL && this.props.notify({
            kind: 'danger',
            message: getMessage('notification.initializationFail')
        });
    };

    render() {
        const {history, pageStatus} = this.props;
        const { pathname } = history.location || '';
        const regex = new RegExp('/myprofile', 'ig');
        const isPathMatchMyProfile = regex.test(pathname);
        return (
            <ConnectedRouter history={history}>
                <div className="boSkeleton">
                    {pageStatus === pageInitializationActionTypes.PAGE_INITIALIZATION_START && <Loading noMessage={true}/>}
                    {pageStatus === pageInitializationActionTypes.PAGE_INITIALIZATION_SUCCESS && <Body/>}
                    {pageStatus === pageInitializationActionTypes.PAGE_INITIALIZATION_SUCCESS && <Header noUserMenu={isPathMatchMyProfile}/>}
                    <div className="foCopyright">© Copyright 2017-2022 Micro Focus or one of its affiliates.</div>
                    <Notifs componentClassName="foNotifications" CustomComponent={Notification}/>
                    <Confirmation />
                </div>
            </ConnectedRouter>
        );
    }
}

export default connect((state, ownProps) => ({
    history: ownProps.history,
    pageStatus: state.pageInitializationStatus
}), {
    initialize: actions.initialize,
    notify: notifActions.notifSend
})(Skeleton);



// WEBPACK FOOTER //
// ./src/app/containers/skeleton/index.js